var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{attrs:{"to":{ name: 'updateComplaint', params: {id: _vm.complaintId}}}},[_c('a-icon',{attrs:{"type":"edit"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }